import { productWithMediaDefinitionApi } from "src/services/api";

/**
 * The canvas product's id differs per environment and changes if the row is
 * ever recreated, so no public link may hardcode one. Everything that needs to
 * open the canvas editor without an id in hand resolves it through here.
 */

/**
 * @dataui/crud answers with a bare array or a { data, count } envelope
 * depending on the query, and the generated client types both as `object`.
 */
export function pickCanvasDefinitionId(payload: unknown): string | null {
  const list = Array.isArray(payload)
    ? payload
    : ((payload as { data?: unknown[] } | null)?.data ?? []);
  if (!Array.isArray(list)) return null;
  const id = (list[0] as { id?: unknown } | undefined)?.id;
  return typeof id === "string" && id ? id : null;
}

/** The oldest active definition of a kind, or null if the shop has none. */
export async function fetchActiveDefinitionIdByKind(kind: string): Promise<string | null> {
  const res =
    await productWithMediaDefinitionApi.getManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(
      undefined, // fields
      undefined, // s
      [`kind||$eq||${kind}`, "active||$eq||true"],
      undefined, // or
      // Oldest first, so adding a second product of the kind never silently
      // moves the public link onto it.
      ["createdAt,ASC"],
      undefined, // join
      1,
      0,
    );
  return pickCanvasDefinitionId(res.data);
}

/** The active canvas definition's id, or null if the shop has none. */
export async function fetchCanvasDefinitionId(): Promise<string | null> {
  return fetchActiveDefinitionIdByKind("canvas");
}
